module.exports = __webpack_public_path__ + "img/title.74617f53.png";